import React, {useEffect} from 'react';

import {NavLink} from 'react-router-dom';

import {Box, Fade, ListItemText, MenuItem, MenuList, Paper, Popper,} from '@mui/material';

import {AppLinkCategory} from '../../../utils/routes';
import {useStyles} from './drawerStyles';
import {DrawerMenu} from './drawerMenu';

function CollapsedDrawerMenuItem(props: {
  classes: ReturnType<typeof useStyles>;
  category: AppLinkCategory;
  selected: boolean;
}) {
  const ref = React.useRef(null);
  const [open, setOpen] = React.useState<boolean>(false);

  const handlePopoverOpen = () => {
    setOpen(true);
  };
  const handlePopoverClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    function windowLeave() {
      setOpen(false);
    }
    window.addEventListener('mouseleave', windowLeave, { passive: true });
    return () => {
      window.removeEventListener('mouseleave', windowLeave);
    };
  }, []);

  return (
    <>
      <MenuItem
        className={props.classes.menuItem}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        selected={props.selected}
        ref={ref}
        disabled={!props.category.enabled && !props.category.entries.some(s => s.enabled)}
      >
        <Box>{props.category.icon}</Box>
        <Box className={props.classes.menuItemText}>{props.category.label}</Box>
      </MenuItem>
      <Popper
        open={open}
        anchorEl={ref?.current}
        placement="right-start"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        transition
        style={{ zIndex: 10000 }}
        modifiers={[
          {
            name: 'preventOverflow',
            enabled: true,
            options: {
              boundariesElement: 'viewport',
              priority: ['bottom', 'top', 'right', 'left'],
            },
          },
        ]}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper
              style={{
                maxHeight: 'calc(100vh - 10px)',
                overflow: 'auto',
              }}
            >
              <MenuList>
                {props.category.entries.map(({ enabled, path, label }, i) => (
                  <MenuItem
                    component={NavLink}
                    className={props.classes.activeMenuItem}
                    key={path}
                    to={path}
                    onClick={handlePopoverClose}
                    disabled={!enabled}
                  >
                    <ListItemText>{label}</ListItemText>
                  </MenuItem>
                ))}
              </MenuList>
            </Paper>
          </Fade>
        )}
      </Popper>
    </>
  );
}

export const CollapsedMenu: DrawerMenu = (props) => {
  return (
    <MenuList className={props.classes.menuList}>
      {props.categories.map((category) => (
        <CollapsedDrawerMenuItem
          key={category.id}
          category={category}
          classes={props.classes}
          selected={category === props.selectedCategory}
        />
      ))}
    </MenuList>
  );
};
